module.exports = __webpack_public_path__ + "files/Spotlight on Skills Participant Guide.091d1c1f.pdf";